import React, { useEffect, useState } from "react"

import Button from "components/shared/Button/Button"
import { Col, Container, Row } from "reactstrap"
import api from "../../services/api"
import Swal from "sweetalert2"
import { Link, Navigate } from "react-router-dom"
import AuthService from "../../services/Auth.service"
import CondominioSelect, {
  empresasToSelectOptions,
} from "../../components/Empresa/CondominioSelect"
import { useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import ImovelImportadorXlsx from "components/Empresa/ImovelImportadorXlsx"

const ImovelCadastro = () => {
  const { id } = useParams()

  const user = AuthService.getCurrentUser()
  const isAdmin = Number(user?.user?.DS_STATUS) === 10
  const initialEmpresas = AuthService.getLinkedEmpresas(user)
  const [empresas, setEmpresas] = useState(initialEmpresas)
  const [selectedEmpresaId, setSelectedEmpresaId] = useState(() => {
    if (id) return id
    const stored =
      typeof sessionStorage !== "undefined"
        ? sessionStorage.getItem("syskeeper:sindicoEmpresaId")
        : null
    if (
      stored &&
      initialEmpresas.some(item => String(item.OID_EMPRESA) === stored)
    ) {
      return stored
    }
    return initialEmpresas[0]?.OID_EMPRESA ?? null
  })

  useEffect(() => {
    if (id) {
      setSelectedEmpresaId(id)
    }
  }, [id])

  useEffect(() => {
    let cancelled = false
    const applyEmpresas = list => {
      if (cancelled) return
      setEmpresas(list)
      setSelectedEmpresaId(current => {
        if (id) return id
        if (list.some(item => String(item.OID_EMPRESA) === String(current))) {
          return current
        }
        return list[0]?.OID_EMPRESA ?? null
      })
    }
    AuthService.refreshEmpresas().then(session => {
      applyEmpresas(AuthService.getLinkedEmpresas(session))
    })
    const onSessionUpdated = event => {
      applyEmpresas(AuthService.getLinkedEmpresas(event.detail))
    }
    window.addEventListener("syskeeper:session-updated", onSessionUpdated)
    return () => {
      cancelled = true
      window.removeEventListener("syskeeper:session-updated", onSessionUpdated)
    }
  }, [id])

  const checkempresa = selectedEmpresaId
  const condoOptions = empresasToSelectOptions(empresas)
  const selectedCondoOption =
    condoOptions.find(
      item => item.value === String(selectedEmpresaId ?? ""),
    ) || null

  const { register, getValues, reset } = useForm({
    defaultValues: {
      IM_COMPLEMENTO: "",
      IM_BLOCO: "",
      CD_IMOVEL: "",
    },
  })

  const submitHandler = event => {
    event.preventDefault()

    const comp = getValues("IM_COMPLEMENTO")
    let bloco = getValues("IM_BLOCO")

    if (!comp || comp.length < 1) {
      Swal.fire({
        icon: "warning",
        text: "favor Colocar o Nr do AP ou casa",
      })
      return
    }

    if (!bloco || bloco.length < 1) {
      bloco = null
    }

    if (!checkempresa) {
      Swal.fire({
        icon: "warning",
        text: "Selecione o condomínio",
      })
      return
    }

    let imovel = {
      OID_CONDOMINIOATUAL: Number(checkempresa),
      IM_COMPLEMENTO: comp,
      IM_BLOCO: bloco,
      CD_IMOVEL: getValues("CD_IMOVEL") ? getValues("CD_IMOVEL") : "",
    }

    api
      .post("/imovel/imovel", imovel)
      .then(() => {
        reset({
          IM_COMPLEMENTO: "",
          IM_BLOCO: "",
          CD_IMOVEL: "",
        })
        Swal.fire({
          icon: "success",
          text: "AP/CASA Cadastrado com sucesso!",
          timer: 3000,
        })
      })
      .catch(function (error) {
        console.log("status: ", error.response?.status)
        if (error.response?.status === 409) {
          Swal.fire({
            icon: "error",
            text:
              error.response?.data?.message ||
              "Já existe um imóvel cadastrado com esses dados.",
          })
          return
        }
        if (error.response?.status === 403) {
          Swal.fire({
            icon: "error",
            text:
              error.response?.data?.message ||
              "Síndicos não podem cadastrar imóveis.",
          })
          return
        }
        console.log(error)
        Swal.fire({
          icon: "warning",
          text: "Serviço Temporariamente Indisponivel",
        })
      })
  }

  if (!isAdmin) {
    return <Navigate to="/moradores" replace />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <label id="component-title">Cadastrar | IMÓVEL</label>
        <Col md={8}>
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item active">
              Aqui será feito o cadastro do AP/CASA, após isso será possivel
              adicionar moradores na página de Moradores.
            </li>
          </ol>
        </Col>
        {!id ? (
          <div>
            <Button
              icon="bx bx-left-arrow-circle"
              iconPosition="left"
              primaryColor="#f8f7ff"
              hoverColor="#f8f7ff"
              text="Voltar"
              link="/moradores"
              styles={{
                marginLeft: "1.5rem",
                background: "#f8f7ff",
                color: "blue",
              }}
            />
          </div>
        ) : (
          <div>
            <Link color="" className="btn " to={`/condominios/`}>
              {" "}
              <i className="mdi mdi-chevron-left" /> Voltar{" "}
            </Link>
          </div>
        )}
        <form className="component-form container" style={{ margin: "0px" }}>
          <div className="container">
            {!id && empresas.length > 1 ? (
              <div className="mb-3 col-6">
                <div className="form-group">
                  <label
                    htmlFor="condominio-imovel"
                    className="col-md-12 col-form-label"
                  >
                    Condomínio*
                  </label>
                  <CondominioSelect
                    inputId="condominio-imovel"
                    options={condoOptions}
                    value={selectedCondoOption}
                    onChange={option =>
                      setSelectedEmpresaId(option?.value ?? null)
                    }
                  />
                </div>
              </div>
            ) : null}
            <div className="mb-3 col-6">
              <div className="form-group">
                <label className="col-md-12col-form-label">
                  Nº AP ou Casa* (Apenas Números ou letra identificatória)
                </label>
                <input
                  {...register("IM_COMPLEMENTO")}
                  className="form-control form-control-lg w-100"
                  type="text"
                  defaultValue=""
                />
              </div>
            </div>
            <div className="mb-3 col-6">
              <div className="form-group">
                <label className="col-md-12col-form-label">
                  Bloco (Caso Existir no Condomínio)
                </label>
                <input
                  {...register("IM_BLOCO")}
                  className="form-control form-control-lg w-100"
                  type="text"
                  defaultValue=""
                />
              </div>
            </div>

            <div className="mb-3 col-6">
              <div className="form-group">
                <label className="col-md-12col-form-label">
                  Código do Imóvel
                </label>
                <input
                  {...register("CD_IMOVEL")}
                  className="form-control form-control-lg"
                  type="text"
                  defaultValue=""
                />
              </div>
            </div>

            <div className="row">
              <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
                <Button
                  icon="ti-user"
                  text="Cadastrar"
                  action={submitHandler}
                  primaryColor="#5d4ec0"
                  hoverColor="#4eadc0"
                />
              </div>
            </div>
          </div>
        </form>

        {checkempresa && (
          <ImovelImportadorXlsx condoId={checkempresa} />
        )}
      </div>
    </React.Fragment>
  )
}

export default ImovelCadastro
